module.exports = __webpack_public_path__ + "static/img/preview-bg-bot.be8b87e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview-bg-bot.png
// module id = kZgc
// module chunks = 1